<template>
  <v-dialog v-model="isVisible" max-width="400px">
    <template v-slot:activator="{ on }">
      <v-btn v-on="on" fab dark color="primary">
        <v-icon dark>mdi-plus</v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-card-title>Add service</v-card-title>
      <v-card-text>
        <v-text-field
          label="Service name"
          required
          v-model="service.serviceName"
          @input="$v.service.serviceName.$touch()"
          :error-messages="ServiceNameErrors"
          maxlength="100"
          counter
        ></v-text-field>

        <v-menu
          ref="menu"
          :close-on-content-click="false"
          v-model="menu2"
          :nudge-right="40"
          :return-value.sync="service.duration"
          transition="scale-transition"
          offset-y
          max-width="290px"
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="service.duration"
              label="Duration hh:mm"
              append-icon="mdi-clock-outline"
              :error-messages="DurationErrors"
              @input="$v.service.duration.$touch()"
              required
              v-on="on"
            ></v-text-field>
          </template>
          <v-time-picker
            v-if="menu2"
            v-model="service.duration"
            @change="$refs.menu.save(service.duration)"
            @input="$v.service.duration.$touch()"
            min="00:05"
            max="08:00"
            format="24hr"
            :allowed-hours="allowedHours"
            :allowed-minutes="allowedMinutes"
          ></v-time-picker>
        </v-menu>

        <v-text-field
          type="number"
          label="Price"
          v-model="service.price"
          @input="$v.service.price.$touch()"
        ></v-text-field>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="SaveService">
          <v-icon dark>mdi-content-save</v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import axios from "axios";
export default {
  data: () => ({
    isVisible: false,
    service: {
      serviceName: "",
      price: 0,
      duration: "00:00"
    },
    menu2: false,
    rules: {
      required: value => !!value || "Required.",
      counter: value => value.length <= 100 || "Max 100 characters"
    }
  }),
  computed: {
    ServiceNameErrors() {
      const errors = [];
      if (!this.$v.service.serviceName.$dirty) return errors;
      !this.$v.service.serviceName.required && errors.push("Name is required");
      return errors;
    },
    DurationErrors() {
      const errors = [];
      if (!this.$v.service.duration.$dirty) return errors;
      !this.$v.service.duration.required && errors.push("Duration is required");
      return errors;
    },

    hasChanged() {
      if (
        this.$v.service.serviceName.$dirty == true ||
        this.$v.service.duration.$dirty == true ||
        this.$v.service.price.$dirty == true
      ) {
        return true;
      } else {
        return false;
      }
    }
  },
  validations: {
    service: {
      serviceName: { required },
      duration: { required },
      price: {}
    }
  },
  methods: {
    allowedHours: v => v <= 8,
    allowedMinutes: v => v % 5 === 0,
    allowedStep: m => m % 5 === 0,
    convertStringToSecond(str) {
      if (str == null) return;
      var p = str.split(":"),
        s = 0,
        m = 1;

      while (p.length > 0) {
        s += 60 * m * parseInt(p.pop(), 10);
        m *= 60;
      }
      return s;
    },
    ValidateService() {
      return this.service.serviceName == null || this.service.duration == null
        ? false
        : true;
    },
    SaveService() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      if (this.ValidateService() == false) {
        this.showError("Could not save service!");
        return;
      }
      this.service.duration = this.convertStringToSecond(this.service.duration);
      this.service.companyId = this.$store.getters.user.details.companyId;
      let mutation = `mutation saveService($service: SaveService!) {
                                saveService(service: $service) {
                                id
                                serviceName
                                duration
                                price
                                companyId
                                }
                            }`;

      axios
        .post("/graphql", {
          query: mutation,
          variables: { service: this.service }
        })
        .then(res => {
          if (res.data.data != null && res.data.data.saveService != null)
            res.data.data.saveService.duration = this.$moment
              .utc(res.data.data.saveService.duration * 1000)
              .format("HH:mm");
          this.$emit("Add", res.data.data.saveService);
          this.isVisible = false;
          this.$v.$reset();
          this.resetServiceObj();
        })
        .catch(error => console.log(error));
    },
    resetServiceObj() {
      this.service = {
        serviceName: "",
        price: 0,
        duration: "00:00"
      };
    }
  }
};
</script>

<style>
</style>